__turbopack_context__.v({
  "contributor": "yxaxZW_contributor",
  "contributor__additional": "yxaxZW_contributor__additional",
  "contributor__email": "yxaxZW_contributor__email",
  "contributor__image": "yxaxZW_contributor__image",
  "contributor__subrole": "yxaxZW_contributor__subrole",
  "contributor__title": "yxaxZW_contributor__title",
});
